import { View, Text, Image } from "@react-pdf/renderer";
import { parseDate } from "helpers/date";
import { IAbnNotice } from "types/AbnNotice/AbnNotice";

import { styles } from "../styles";

export function Signature({
  activeAbnNotice,
}: {
  activeAbnNotice?: IAbnNotice | null;
}) {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 10,
          alignItems: "flex-end",
          // Unsigned (printed to sign by hand): leave writing room above the lines, as the staff
          // witness line has. A signed ABN's signature image fills that space itself.
          paddingTop: activeAbnNotice?.signatureUrl ? 0 : 30,
        }}
      >
        <View
          style={{
            width: "50%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <View
            style={{
              borderBottom: "1px solid black",
              paddingBottom: 2,
              width: "100%",
            }}
          >
            {activeAbnNotice?.signatureUrl && (
              <Image
                style={{ width: 100, height: "auto" }}
                src={activeAbnNotice?.signatureUrl}
              />
            )}
          </View>
          <Text
            style={{
              ...styles.bodyText,
              fontSize: "9px",
              fontFamily: "Helvetica-Oblique",
              marginBottom: 0,
            }}
          >
            Signature of Patient/Guardian
          </Text>
        </View>
        <View
          style={{
            width: "50%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <View
            style={{
              borderBottom: "1px solid black",
              paddingBottom: 2,
              width: "100%",
            }}
          >
            {activeAbnNotice?.createdAt && (
              <Text
                style={{ ...styles.bodyText, fontSize: "9px", marginBottom: 0 }}
              >
                {parseDate(activeAbnNotice?.createdAt)}
              </Text>
            )}
          </View>
          <Text
            style={{
              ...styles.bodyText,
              fontSize: "9px",
              fontFamily: "Helvetica-Oblique",
              marginBottom: 0,
            }}
          >
            Date
          </Text>
        </View>
      </View>
      <View
        style={{
          width: "50%",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          paddingTop: 30,
        }}
      >
        <View
          style={{
            borderBottom: "1px solid black",
            paddingBottom: 2,
            width: "100%",
          }}
        />
        <Text
          style={{
            ...styles.bodyText,
            fontSize: "9px",
            fontFamily: "Helvetica-Oblique",
          }}
        >
          Signature of Staff Witness
        </Text>
      </View>
    </View>
  );
}
